import {CONST} from "../config/CONST";

export const headerMenu = (function ($) {

    const $DOM = {};

    function init(headerMenuItems) {

        $DOM.header = $("header.header__top");
        $DOM.nav = $DOM.header.find("nav");
        $DOM.navMenu = $DOM.nav.children("ul");

        renderMenu(headerMenuItems);

    }

    function renderMenu(menuItems) {

        const $newMenu = $('<ul/>');

        menuItems.forEach((item) => {

            let itemUrl = item.CODICE === CONST.dynamicHeader.mainSiteBlogPageCode ? `/` : item.URL ? `${CONST.dynamicHeader.mainSiteBaseUrl}/${item.URL}` : '#';
            let $item = $(`
                <li>
                    <a href="${itemUrl}">${item.DESCR}</a>
                </li>
            `);

            if(item.FOGLIE && item.FOGLIE.length > 0) {
                let $subMenu = $(`<ul></ul>`);
                item.FOGLIE.forEach((subItem) => {
                    let subItemUrl = item.CODICE === CONST.dynamicHeader.mainSiteBlogPageCode ? subItem.URL : `${CONST.dynamicHeader.mainSiteBaseUrl}/${subItem.URL}`;
                    let $subItem = $(`
                        <li>
                            <a href="${subItemUrl || '#'}">${subItem.DESCR}</a>
                        </li>
                    `);
                    $subMenu.append($subItem);
                });
                $item.append($subMenu);
            }

            $newMenu.append($item);

        });

        $DOM.navMenu.prepend($newMenu.html());

        $DOM.navMenu.show();
        navInit();

    }


    function navInit() {



        $DOM.navMenuLev1Items = $DOM.navMenu.children("li");
        $DOM.navMenuLev2Items = $DOM.navMenuLev1Items.find("ul");

        addMenuArrows();

        duplicateItemsForMobileMenu();
        handleMenu();
        handleBurger();

    }

    function addMenuArrows() {
        $DOM.navMenuLev1Items.each(function(){
           if($(this).children("ul").length > 0) {
               $(this).addClass("has-children");
           }
        });
    }

    function handleMenu() {

        // $DOM.navMenuLev1Items.on("mouseenter", function(){
        //     $DOM.navMenuLev2Items.removeClass("animate-in").removeClass("is-visible");
        // })
        $DOM.navMenuLev1Items.on("mouseenter", function(){
            $DOM.navMenuLev2Items.removeClass("animate-in").removeClass("is-visible");
            var $el = $(this).children("ul");
            $el.addClass("is-visible");
            window.setTimeout(function(){
                $el.addClass("animate-in");
            },15);
        });
        $DOM.nav.on("mouseleave", function(){
            window.setTimeout(function() {
                $DOM.navMenuLev2Items.removeClass("animate-in").removeClass("is-visible");
            }, 250);
        });

        // mobile
        $DOM.navMenuLev1Items.filter(".has-children").children("a").on("click", function(e) {
            if($(window).width() < 768) {
                e.preventDefault();
                $(this).toggleClass("is-open");
                var $submenu = $(this).next("ul");
                $submenu.slideToggle();
            }
        });

    }


    function duplicateItemsForMobileMenu() {
        $DOM.navMenuLev1Items.filter(".has-children").each(function () {
            var $lev1link = $(this).children("a");
            var $cloned = $lev1link.clone();
            var $submenu = $(this).children("ul");
            var $li = $("<li/>");
            $li.append($cloned);
            $li.addClass("d-md-none").addClass("d-lg-none").addClass("d-xl-none");
            $submenu.prepend($li);
        });
    }

    function handleBurger() {
        $(".header__togglenav").on("click", function(e){
            e.preventDefault();
            $(this).toggleClass("is-active");
            toggleMobileMenu();
        });
    }

    function toggleMobileMenu() {
        $("html").toggleClass("fixed");
        $DOM.nav.toggleClass("mobile-is-visible");
    }

    return {
        init: init
    }

})(jQuery);
